import React from 'react'
import { Button } from '@the-platform-group/component-library'
import { Add as CreateIcon } from '@the-platform-group/component-library/Icons'
import { DataGrid } from '@the-platform-group/component-library/DataGrid'
import useUserForm from 'components/UserForm/useUserForm'
import useColumnConfig from 'pages/Users/hooks/useColumnConfig'
import useAddUserModal from 'pages/Users/hooks/useAddUserModal'
function UsersTable({ isLoading, users, pagination, handlePageChange, handleRowsChange }) {
  const { page, itemCount, pageSize } = pagination

  const { getUserFormModal, handleUserEdit } = useUserForm()
  const { openAddUserModal } = useAddUserModal()

  const columns = useColumnConfig({ handleUserEdit })

  return (
    <>
      <DataGrid
        advancedToolbarProps={{
          slots: {
            // exportButton is the slot on the right side of the toolbar — used for add user here
            exportButton: (
              <Button
                startIcon={<CreateIcon />}
                variant="outlined"
                size="small"
                onClick={openAddUserModal}
              >
                Add new user
              </Button>
            ),
          },
        }}
        columns={columns}
        commonColumnProps={{ headerAlign: 'left' }}
        rows={users}
        sx={{
          '.MuiDataGrid-actionsCell .MuiIconButton-root': { px: 1 },
          '.hoverCell': {
            '&.MuiDataGrid-cell:hover span, &.MuiDataGrid-cell:hover .MuiButtonBase-root': {
              display: 'block',
              fontSize: 11,
            },
            'span, .MuiButtonBase-root': { display: 'none' },
          },
        }}
        loading={isLoading}
        localeText={{
          noRowsLabel:
            'Looks like nothing matches your search. Try removing some criteria or attempt a new search.',
        }}
        name="usersTable"
        page={page}
        pageSize={pageSize}
        onPageChange={handlePageChange}
        onPageSizeChange={handleRowsChange}
        rowCount={itemCount}
        pageSizeOptions={[10, 25, 50]}
      />
      {getUserFormModal()}
    </>
  )
}

export default UsersTable
